import React from "react";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import Header from "./components/Header/Header.js";
import Routes from "./Routes.js";
import GlobalStyles from "@mui/material/GlobalStyles";
import getGlobalStyles from "globalStyles.js";
import { queryClient } from "./store/serverStore.js";
import ErrorBoundary from "layouts/ErrorBoundary.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <GlobalStyles styles={getGlobalStyles()} />
      <BrowserRouter>
        <ErrorBoundary>
          <Header />
          <Routes />
          <ToastContainer />
        </ErrorBoundary>
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default App;
